export enum OptionsMenuEnum {
  duplicate = 'duplicate',
  move = 'move',
  duplicateAndMove = 'duplicateAndMove',
  informations = 'informations',
  delete = 'delete'
}
